import {
    CATEGORY_DELETE_SUCCESS,
    CATEGORY_DELETE_START,
    CATEGORY_DELETE_ERROR
} from '../../../constants/index';
import { setLoaderComplete, setLoaderStart } from '../../loader/loader'
import { showToaster } from '../../../helpers/toastrMessgaes/showToaster';
import { deleteCategoryMutation, getAllCategory } from '../../../lib/graphql';

export const deleteCategory = (id, currentPage) => {
    return async (dispatch, getState, { client }) => {

        try {

            dispatch({
                type: CATEGORY_DELETE_START
            });

            dispatch(setLoaderStart('DeleteCategory'));

            const { data } = await client.mutate({
                mutation: deleteCategoryMutation,
                variables: {
                    id
                },
                refetchQueries: [{ query: getAllCategory, variables: { currentPage, searchList: '' } }]
            });

            if (data?.deleteCategory?.status == 200) {
                dispatch({
                    type: CATEGORY_DELETE_SUCCESS
                });
                showToaster({ messageId: 'removeCatSuccess', toasterType: 'success' });
            } else {
                dispatch({
                    type: CATEGORY_DELETE_ERROR
                });
                showToaster({ messageId: 'errorMessage', requestContent: { content: data?.deleteCategory?.errorMessage }, toasterType: 'error' });
            }
            dispatch(setLoaderComplete('DeleteCategory'));
        } catch (err) {
            showToaster({ messageId: 'catchMessage', requestContent: { content: err }, toasterType: 'error' });
            dispatch({
                type: CATEGORY_DELETE_ERROR
            });
        }

    }
};